/* RegistrationNamespaces.js */

"use strict";
const RegistrationNamespaces = require("@gluenetworks/solution-definitions").getRegistrations();
module.exports = RegistrationNamespaces;
Object.freeze(module.exports);
